import React, { useEffect } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import PageSection from "components/layout/PageSection";
import Typography from "@material-ui/core/Typography";
import Spacer from "components/Spacer";

import citroenLogo from "assets/images/creditsPage/CitroenLogo.png";
import fordOfficialLicensedProduct from "assets/images/creditsPage/FordOfficialLicensedProduct.png";
import pirelliLogo from "assets/images/creditsPage/PirelliLogo.jpg";
import renaultLogo from "assets/images/creditsPage/RenaultLogo.jpg";
import vwLogo from "assets/images/creditsPage/VWLogo.jpg";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            paddingTop: theme.spacing(4),
            display: "flex",
            flexDirection: "column",
            "& img": {
                maxWidth: 200,
            },
        },
    })
);

export default function CreditsPage() {
    const classes = useStyles();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const spacerSize = 2;

    return (
        <>
            <PageSection>
                <div className={classes.root}>
                    <Typography variant="h3" gutterBottom>
                        DIRT 5 Credits
                    </Typography>
                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        Manufactured under license from Ariel Limited
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        Armor All and STP are trademarks of Energizer Auto and are used with
                        permission by The Codemasters Software Company Limited. All other brand
                        names or trademarks are marks of their respective owners and Energizer Auto
                        is not affiliated with such owners or their marks.
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        "Aston Martin". "Aston Martin Racing" and related logos and other trade
                        marks are owned, licensed and/or used by Aston Martin and Aston Martin
                        Racing. These trade marks may not be used, amended and/or reproduced without
                        permission. All rights are reserved.
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        Trademarks, design patents and copyrights are used with the approval of the
                        owner AUDI AG.
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        Manufactured under license from BLITZWORLD BUGGIES LTD
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        The BMW logo, the MINI Logo, the BMW word mark and the MINI word mark as
                        well as the BMW and MINI model designations are trademarks of BMW AG and are
                        used under License.
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        The HELIOTROPE BP and BP ULTIMATE ARE trade marks and are used with
                        permission from BP p.l.c.
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        Manufactured under license from Brenthel Industries
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        <img src={citroenLogo} alt="Citroen Logo" />
                    </Typography>

                    <Typography gutterBottom>
                        The CASTROL logo is a trade mark and is used with permission from Castrol
                        Limited
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        Manufactured under license from Cosworth Group Holdings Limited
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>Manufactured under license from Exomotive</Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        Firestone and the Firestone and F-shield logos are registered trademarks of
                        Bridgestone Brands, LLC and Bridgestone Licensing Services, Inc., and are
                        used with permission.
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        Manufactured under license of FCA Italy S.p.A., “FIAT” and “LANCIA” are
                        trademarks of FCA Group Companies.
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        <img
                            src={fordOfficialLicensedProduct}
                            alt="Ford Official Licensed Product"
                        />
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        Ford Motor Company Trademarks and Trade Dress used under license to The
                        Codemasters Software Company Limited.
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        General Motors Trademarks used under license to The Codemasters Software
                        Company Limited.
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        Manufactured under license from Laffite LLC
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        Produced under licence from Group Lotus plc. LOTUS, the Lotus Roundel, car
                        names and all associated logos and distinctive designs are trade marks of
                        Group Lotus plc.
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        MITSUBISHI MOTORS CORPORATION trademarks, designs, copyrights and/or other
                        intellectual property rights are used under license.
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        MOTUL and the MOTUL LOGO are registered trademarks of MOTUL (SA). All rights
                        reserved
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        The NO FEAR™ trade mark and copyright © belong to No Fear International
                        Limited and are used under license by The Codemasters Software Company
                        Limited
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        PIRELLI and <img src={pirelliLogo} alt="Pirelli Logo" /> are registered
                        trademarks of Pirelli {"&"} C. S.p.A. and are used under license.
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        The trademarks Porsche, Porsche Crest, Porsche Logotype, Carrera, and 911
                        are used under license of Porsche AG.
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        Produced under license of PUMA SE. PUMA® (wordmark) and the Cat logo are
                        trademarks of PUMA SE.
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        Manufactured under license from Automobiles Peugeot.
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        Red Bull® Marks are licensed by Red Bull GmbH/Austria
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        <img src={renaultLogo} alt="Renault Logo" />
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        RENAULT Official License Products. Vehicle models and trademarks protected
                        by intellectual property laws. Used with permission of RENAULT. All rights
                        reserved.
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        ŠKODA and the “winged arrow in the circle” (ŠKODA logo) are registered
                        trademarks owned and licensed by ŠKODA AUTO a.s. www.skoda-auto.com{" "}
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        “SUBARU”, “IMPREZA”, “WRX”, "STI", all other associated marks, emblems and
                        body designs are properties of SUBARU CORPORATION and used with permission.
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        Shelby® and GT-350® are registered trademarks and/or intellectual property
                        of Carroll Shelby Licensing, Inc. and are used under license.
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        Toyo Tires is a trademark belonging to Toyo Tire Corporation
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        Trademarks, design patents and copyrights are used with the permission of
                        the owner Volkswagen AG
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        <img src={vwLogo} alt="VW Logo" />
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography gutterBottom>
                        Any liveries that appear on Volkswagen vehicles are fictional unless stated
                        that they are Official VW Motorsport Partners
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography
                        style={{ fontWeight: 900, textDecoration: "underline" }}
                        gutterBottom
                    >
                        With Special Thanks To:
                    </Typography>

                    <Typography>James Pumphrey</Typography>
                    <Typography>Nolan Sykes</Typography>

                    <Spacer size={spacerSize} />

                    <Typography
                        style={{ fontWeight: 900, textDecoration: "underline" }}
                        gutterBottom
                    >
                        Livery Artists:
                    </Typography>

                    <Typography>Death Spray Custom</Typography>
                    <Typography>Sean Bull – Sean Bull Design Limited</Typography>

                    <Spacer size={spacerSize} />

                    <Typography
                        style={{ fontWeight: 900, textDecoration: "underline" }}
                        gutterBottom
                    >
                        Locations:
                    </Typography>

                    <Typography>
                        Cape Town Stadium – The Cape Town Stadium Company (RF) SOC
                    </Typography>
                    <Typography>Triangle House, Cape Town – Louis Karol Architects</Typography>
                    <Typography>
                        Monumento do Cristo Redentor, Rio de Janeiro - Arquidiocese do Rio de
                        Janeiro
                    </Typography>

                    <Spacer size={spacerSize} />

                    <Typography
                        style={{ fontWeight: 900, textDecoration: "underline" }}
                        gutterBottom
                    >
                        Manufacturers:
                    </Typography>

                    <Typography>Ariel Limited</Typography>

                    <Typography>Armada Engineering, Inc.</Typography>

                    <Typography>Audi AG</Typography>

                    <Typography>Automobiles Citroën</Typography>

                    <Typography>Automobiles Peugeot</Typography>

                    <Typography>Blitzworld Buggies Limited</Typography>

                    <Typography>Brenthel Industries</Typography>

                    <Typography>BMW AG</Typography>

                    <Typography>Carroll Shelby Licensing, Inc.</Typography>

                    <Typography>Cosworth Group Holdings Limited</Typography>

                    <Typography>DeBerti Designs</Typography>

                    <Typography>Exomotive</Typography>

                    <Typography>FCA Italy S.p.A.</Typography>

                    <Typography>Fibrewerx Incorporated</Typography>

                    <Typography>Ford Motor Company</Typography>

                    <Typography>Industrias Lahoz 2004 S.L.</Typography>

                    <Typography>Jimco Racing Inc</Typography>

                    <Typography>Laffite LLC</Typography>

                    <Typography>Lance Smith, Inc.</Typography>

                    <Typography>LP Racing</Typography>

                    <Typography>MITSUBISHI MOTORS CORPORATION</Typography>

                    <Typography>M Sport Ltd</Typography>

                    <Typography>Prodrive (Holdings) Ltd</Typography>

                    <Typography>ŠKODA AUTO a. s.</Typography>

                    <Typography>Sodicars Racing</Typography>

                    <Typography>Williams Grand Prix Engineering Limited</Typography>

                    <Spacer size={spacerSize} />

                    <Typography
                        style={{ fontWeight: 900, textDecoration: "underline" }}
                        gutterBottom
                    >
                        Sponsors:
                    </Typography>

                    <Typography>3M Svenska AB</Typography>

                    <Typography>AccuWeather, Inc.</Typography>

                    <Typography>
                        Adolf Würth GmbH {"&"} Co. KH and Würth International AG
                    </Typography>

                    <Typography>Advanced Clutch Technology Incorporated</Typography>

                    <Typography>AEM Performance Electronics</Typography>

                    <Typography>Alcon Components Limited</Typography>

                    <Typography>Alpinestars S.p.A.</Typography>

                    <Typography>Apple Inc.</Typography>

                    <Typography>Arai Helmet (Europe) B.V.</Typography>

                    <Typography>Autometer Products, Inc.</Typography>

                    <Typography>Bardahl Manufacturing Corporation</Typography>

                    <Typography>Basic Trademark S.r.l</Typography>

                    <Typography>BBS GmbH</Typography>

                    <Typography>Bella-Veneet Oy</Typography>

                    <Typography>Bioextra Co. Ltd.</Typography>

                    <Typography>BMC Srl</Typography>

                    <Typography>Borla Performance Industries, Inc.</Typography>

                    <Typography>Braille Battery, Inc.</Typography>

                    <Typography>Brembo S.p.A.</Typography>

                    <Typography>BRIDGESTONE BRANDS, LLC</Typography>

                    <Typography>BRIDGESTONE LICENSING SERVICES, INC</Typography>

                    <Typography>Bridgestone Corporation</Typography>

                    <Typography>Bronco ATV Technologies</Typography>

                    <Typography>Bullet Race Engineering</Typography>

                    <Typography>Castrol Limited</Typography>

                    <Typography>Cobra Seats Limited</Typography>

                    <Typography>Cobra Sport Exhausts UK Ltd</Typography>

                    <Typography>Compomotive International Limited</Typography>

                    <Typography>Cooper Tire {"&"} Rubber Company</Typography>

                    <Typography>Corbeau Seats Ltd.</Typography>

                    <Typography>Custom Wheel House, LLC</Typography>

                    <Typography>DirtFish, LLC</Typography>

                    <Typography>DT (Automotives) Ltd T/A Demon Tweeks</Typography>

                    <Typography>Enkei International</Typography>

                    <Typography>EXEDY Globalparts Corporation</Typography>

                    <Typography>Fatlace LLC</Typography>

                    <Typography>Fitment Industries</Typography>

                    <Typography>Fondmetal S.p.A.</Typography>

                    <Typography>Forge Motorsport Inc.</Typography>

                    <Typography>Francis Tuthill Limited</Typography>

                    <Typography>GIP Development SARL</Typography>

                    <Typography>The Goodyear Tire {"&"} Rubber Company</Typography>

                    <Typography>
                        H{"&"}R Spezialfedern GmbH {"&"} Co. KG
                    </Typography>

                    <Typography>Heinrich Eibach GmbH</Typography>

                    <Typography>HKS Co., Ltd.</Typography>

                    <Typography>Holinger Engineering</Typography>

                    <Typography>Hoosier Racing Tire Corporation</Typography>

                    <Typography>Innov8 Racing Inc.</Typography>

                    <Typography>ITT Ltd</Typography>

                    <Typography>ITW Global Tire Repair Inc.</Typography>

                    <Typography>JNC Wheels</Typography>

                    <Typography>JVCKENWOOD Corporation</Typography>

                    <Typography>K{"&"}N Engineering, Inc.</Typography>

                    <Typography>König American</Typography>

                    <Typography>Kumho Tyre (UK) Ltd</Typography>

                    <Typography>LeMans Corporation</Typography>

                    <Typography>Liqui Moly GmbH</Typography>

                    <Typography>Logitech Europe S.A.</Typography>

                    <Typography>Luigi Lavazza S.p.A.</Typography>

                    <Typography>Mad Croc / Ultra Premium Brands Ltd.</Typography>

                    <Typography>Mäkelä Auto Tuning Oy</Typography>

                    <Typography>Marelli Europe S.p.A.</Typography>

                    <Typography>Michelin Lifestyle Ltd</Typography>

                    <Typography>Millers Oils Limited</Typography>

                    <Typography>Mondelez Europe GmbH</Typography>

                    <Typography>Monster Energy Company</Typography>

                    <Typography>MoTeC Pty Ltd</Typography>

                    <Typography>MOTUL S.A.</Typography>

                    <Typography>Mountune Limited</Typography>

                    <Typography>© M-Sport Ltd 2019</Typography>

                    <Typography>No Fear International Limited</Typography>
                    
                    <Typography>Oakley Inc.</Typography>

                    <Typography>Öhlins Racing AB</Typography>

                    <Typography>OMP Racing S.p.A.</Typography>

                    <Typography>Oy Poppamies</Typography>

                    <Typography>OZ S.p.A</Typography>

                    <Typography>PepsiCo</Typography>

                    <Typography>PIAA UK LTD</Typography>

                    <Typography>Pipercross Performance Filters</Typography>

                    <Typography>Pit Viper LLC</Typography>

                    <Typography>Playseat ® B.V.</Typography>

                    <Typography>Power Automedia, LLC</Typography>

                    <Typography>Prodrive (Holdings) Ltd</Typography>

                    <Typography>Puma SE</Typography>

                    <Typography>Ravensberger Schmierstoffvertrieb GmbH</Typography>

                    <Typography>Rimstock Limited</Typography>

                    <Typography>RONAL AG</Typography>

                    <Typography>R.T. Quaife Engineering Ltd</Typography>

                    <Typography>Sabelt S.p.A.</Typography>

                    <Typography>Shure Incorporated</Typography>

                    <Typography>Simpson Performance Products, Inc.</Typography>

                    <Typography>Skyjacker Suspensions</Typography>

                    <Typography>Snap-on Incorporated</Typography>

                    <Typography>Sparco S.p.A.</Typography>

                    <Typography>Spax Performances</Typography>

                    <Typography>S.P.E.C., Inc.</Typography>

                    <Typography>Spy Optic Inc.</Typography>

                    <Typography>Stand 21 Racewear</Typography>

                    <Typography>Stanley Black {"&"} Decker, Inc.</Typography>

                    <Typography>SteelSeal Ltd</Typography>

                    <Typography>Stillwater Designs</Typography>

                    <Typography>Stilo S.r.l.</Typography>

                    <Typography>Sumitomo Rubber Industries, Ltd.</Typography>

                    <Typography>Sunoco LP</Typography>

                    <Typography>Tecnología y Fabricación, S.A.</Typography>

                    <Typography>TEIN, INC.</Typography>

                    <Typography>Teng Tools UK Limited</Typography>

                    <Typography>ThyssenKrupp Bilstein GmbH</Typography>

                    <Typography>Toyo Tire Corporation</Typography>

                    <Typography>TrailReady Products LLC</Typography>

                    <Typography>Trust Co. Ltd Japan</Typography>

                    <Typography>Unil Lubricants N.V.</Typography>

                    <Typography>Valvoline LLC</Typography>

                    <Typography>VP Racing Fuels, Inc.</Typography>

                    <Typography>Wheelpros LLC</Typography>

                    <Typography>Xite Energy</Typography>

                    <Typography>The Yokohama Rubber Co., Ltd.</Typography>

                    <Typography>ZF Friedrichshafen AG</Typography>

                    <Typography>ZF Services UK Limited</Typography>
                </div>
            </PageSection>
        </>
    );
}
